import walidacjaPrzebiegu from '@components/form/validation/field/przebieg'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Przebieg',
    name: 'przebieg',
    type: 'number',
    unit: 'km',

}, walidacjaPrzebiegu)